import {MAX_PROMO_PHOTO_SIZE_MB} from './MAX_PROMO_PHOTO_SIZE_MB';

const BYTES_PER_MB = 1024 * 1024;

export const MAX_PROMO_PHOTO_SIZE_IN_BYTES = MAX_PROMO_PHOTO_SIZE_MB * BYTES_PER_MB;
